// routes/proposal-presentation.js — 열린 제안 한 건을 화면이 읽는 자리.
//
// **왜 이 파일이 있는가.**
// 2026-08-10 에 승격의 델타 방어가 복원되면서(`task-ledger/src/domain/candidate-context.js`),
// 제안이 실어 보내는 `candidateContext.confirmed` 는 세 모양 중 하나가 됐다 —
// 배열(옛 형식, 통째로 교체) · `{add, remove}`(델타) · **아예 없음**(말하지 않은 칸).
// 화면은 그걸 계속 배열로 가정하고 있었고, Bridge 로 붙은 로컬 AI 가 델타 제안을 하나
// 올리는 순간 `.length` 는 undefined 가 되고 `diff()` 는 던졌다 — 사람의 Task 상세가 통째로
// 터진다(Preact 에 error boundary 가 없다).
//
// **고치는 방향은 화면이 델타를 다시 해석하는 것이 아니다.** `resolveCandidate` 를 여기 옮겨
// 적으면 승격 규칙이 두 곳에 살고, 언젠가 조용히 갈린다 — 이 리포에서 같은 실수가 이미 세 번
// 사고를 냈다(liveness 술어 · 후보 판정 · 캐시 키 규약). 그래서 Ledger 가 **승격과 같은
// 계산으로** 해석한 값(`resolvedContext`)과 기준 버전 대비 변화(`resolvedChange`)를 Context
// Pack 에 함께 싣고, 화면은 그것만 읽는다.
//
// 그래서 이 파일에는 `add`·`remove` 라는 말이 없다. 있으면 그게 곧 규칙의 두 번째 사본이다.

/**
 * 서버가 해석해 준 제안 한 건. 서버가 그 칸을 주지 않았으면 **null** 이다 —
 * 없는 것을 지어내지 않는다. 부르는 쪽은 null 을 "이 제안은 읽을 수 없다"로 그린다.
 *
 * `proposal.candidateContext`(제안이 실제로 한 말)는 여기서 읽지 않는다. 그건 원장의 기록이지
 * 화면이 셈할 값이 아니다.
 */
export function readProposal(proposal) {
  const context = proposal?.resolvedContext;
  const change = proposal?.resolvedChange;
  if (!context || !change) return null;

  return {
    purpose: context.purpose,
    confirmed: context.confirmed,
    openQuestions: context.openQuestions,
    counts: {
      confirmed: context.confirmed.length,
      openQuestions: context.openQuestions.length,
      referenceIds: context.referenceIds.length,
    },
    // 「이 제안이 승격되면 확정 사실 N건이 빠지고 M건이 들어옵니다」의 N·M.
    // 무엇을 같은 사실로 볼지는 Ledger 가 정한다 — 화면은 세기만 한다.
    removed: change.confirmed.removed,
    added: change.confirmed.added,
  };
}
